<template>
  <rent-configurable-product v-if="isRentalProduct" />
  <buy-configurable-product v-else />
</template>

<script>
import { mapGetters } from 'vuex'
import RentConfigurableProduct from './RentConfigurableProduct.vue'
import BuyConfigurableProduct from './BuyConfigurableProduct.vue'

export default {
  name: 'ConfigurableProduct',
  components: {
    RentConfigurableProduct,
    BuyConfigurableProduct
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct'
    }),
    isRentalProduct () {
      const product = this.getCurrentProduct
      return (product.sirental_price && product.sirental_price.length > 0) ||
        (product.configurable_children && product.configurable_children.some(child => child.sirental_price && child.sirental_price.length > 0))
    }
  }
}
</script>
